import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import ComponentErrorBoundary from '../../../components/component-error-boundary';

export default function Tags(props) {



  const handleKeyDown = event => {

    switch (event.key) {
      case "Enter": {
        event.preventDefault();
        event.stopPropagation();
        if (event.target.value.length > 0) {
          var mapVal=[...props.value,event.target.value];
          props.onSelectValue(mapVal);
        }
        break;
      }
      default:
    }
  };




  return (
    <div>
    <ComponentErrorBoundary value="Type list value and press enter">
      <Autocomplete
        multiple
        freeSolo
        options={[]}
        getOptionLabel={option => option}
        value={props.value}
        disabled={props.disabled===undefined?false:props.disabled}
        onChange={(event, newValue) => {props.onSelectValue(newValue);}}
        onBlur={()=>{props.generateListValues();}}
        renderInput={params => {
          params.inputProps.onKeyDown = handleKeyDown;
          return (
            <TextField
              {...params}
              variant="standard"
              label="List values"
              placeholder="Type your list values and press Enter For e.g. type Abc and press Enter"
              margin="normal"
              fullWidth
              className='valuemap-content'
            />
          );
        }}
      />
      </ComponentErrorBoundary>
    </div>
  );
}
